import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeDocumentTeaser from './Teaser';
import NodeDocumentPage from './Page';
import { NodeDocument } from '../../../types/nodes';

interface NodeDocumentProps {
  entity: ImmutableEntity<NodeDocument>;
  viewMode: string;
}

const NodeDocumentWrapper: React.FC<NodeDocumentProps> = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeDocumentTeaser entity={entity} />;
    default:
      return <NodeDocumentPage entity={entity} />;
  }
};

export default NodeDocumentWrapper;
